import { useMutation, useQueryClient } from '@tanstack/react-query';
import { tFinancialService } from 'src/infra/services/tFinancialService';
import { DeleteInvoiceDto } from 'src/generated/services/TFinancialApi';
import { CacheKeys, cacheKeysUtil } from 'src/utils/cacheKeysUtil';

export const useDeleteInvoices = () => {
  const queryClient = useQueryClient();

  return useMutation(async (data: DeleteInvoiceDto) => tFinancialService.api.deleteInvoices(data), {
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries(cacheKeysUtil.getNotifications()),
        queryClient.invalidateQueries({
          exact: false,
          queryKey: [CacheKeys.getInternalActionNeeded],
        }),
        queryClient.invalidateQueries({
          exact: false,
          queryKey: [CacheKeys.getInternalIssues],
        }),
        queryClient.invalidateQueries({
          exact: false,
          queryKey: [CacheKeys.getInternalFiles],
        }),
      ]);
    },
  });
};
